// extracted by mini-css-extract-plugin
export default {"container":"ArticlesPage_container__QR1W7","underline":"ArticlesPage_underline__QhTgM"};